module.exports = __webpack_public_path__ + "img/kv__hands1.9ea672cc.svg";